// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","red":"Button_red__qhH5+","white":"Button_white__QBg8M","loading":"Button_loading__2RI7O","none":"Button_none__dXXw3"};